import { merge } from 'lodash-es'

import enApp from 'locales-gen/en/app.locales-gen.json'
import enShared from 'locales-gen/en/shared.locales-gen.json'

I18n.translations.en = merge(enShared, enApp)
